module.exports = "https://coinrabbit.io/_next/static/images/valerios-baglaridis-aefab1b7dec692c29a3493794d0d8b6f.png";